import { sanitize } from 'dompurify'

export const sanitizeHTML = html => {
  return sanitize(html)
}
